import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { selectLogoScale } from '../store/selectors/derived';
import { getHeaderHeight, getLogoHeight } from '../util/ui';
import useWindowSize from './useWindowSize';

/*
 * App bar logo scale and the two heights derived from it.
 *
 * Every consumer reads the header height from here so the bar, the logo and the sticky offsets
 * below it stay in agreement — scale is null for legacy experiences, which resolve to a fixed height.
 */
export const useLogoScale = () => {
  const { pathname } = useLocation();
  const { mobile } = useWindowSize();

  const selectScale = useMemo(() => selectLogoScale(pathname), [pathname]);
  const scale = useSelector(selectScale);

  const logoHeight = useMemo(() => getLogoHeight(mobile, scale), [mobile, scale]);
  const headerHeight = useMemo(() => getHeaderHeight(mobile, scale), [mobile, scale]);

  return { scale, logoHeight, headerHeight };
};
